import {i18nInit} from 'root/internationalization/config';
const config = {
    "APIs": {
        "submitEvaluation": "user_form/submit",
        "saveEvaluation": "user_form/save",
        "sendEvaluation": "user_form/send",
        "executeEvaluationWorkflow":"user_form/executeWorkflowAction",
        "deleteEvaluation": "user_form/delete",
        "getEvaluations": "evaluations",
        "getEvaluationForm": "user_form",
        "getEvaluationType": "evaluations/getOnDemandEvalTypes",
        "triggerEvaluation": "entityForm/save",
        "triggerCallbackEvaluation" : "evaluations/getRedirect",
        "getRequiredEvaluations": "evaluations/getRequiredEvaluations",
        "getHistory" : "history",
    },
    "map": {
		"EVALUATIONS_MODULE": {
            "name":"lbl.EVALUATIONS",
            "fallbackName":"Evaluations",
            "path":"evaluations",
            "showInMenu": false,
            "entryPoint": "EVALUATIONS_LIST"
		},
        "TRIGGER_EVALUATION": {
            "name":i18nInit.t("lbl.TRIGGER_NEW_EVAL","Trigger New Evaluation"),
            "path":"evaluations/trigger",
			"showInMenu": true
        },
		"EVALUATIONS_LIST": {
            "name":"lbl.EVALUATIONS",
            "fallbackName":"Evaluations",
            "path":"evaluations",
			"showInMenu": false
		},
		"EVALUATION_FORM": {
            "name":"lbl.EVALUATION_FORM",
            "fallbackName":"Evaluation Form",
            "path":"evaluations/form",
			"showInMenu": false
		}
    }
}

export default config;